export default __webpack_public_path__ + "media/levvy-logo.48873.png";